module.exports = __webpack_public_path__ + "img/c2bd54a.png";